import { queryOptions } from '@tanstack/react-query';

import { getJobPositionQuery } from './shared';

export const getJobPositionQueryOptions = (id: string) => queryOptions(getJobPositionQuery(id));
